// extracted by mini-css-extract-plugin
module.exports = {"holder":"styles_holder__8207A","category":"styles_category__RoT6K","selected":"styles_selected__H4FYo"};